import { RoleEnum } from "./invitation.types";

export interface ProfileType {
  id?: number;
  profile: string;
  url_slug?: string;
  name: RoleEnum;
  attributes: AttributesType;
  access: ProfileAccessType;
  inclusion_criteria: InclusionType;
  consent: ConsentType;
  site: SiteType;
}

export enum ProfileFieldCollectionStateEnum {
  HIDDEN = 'HIDDEN',
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED'
}

export type ProfileFieldKeyType =
  | 'nickname'
  | 'email'
  | 'phonenumber'
  | 'external_id'
  | 'firstname'
  | 'lastname';

export type ProfileAccessSignInModeType =
  | IdentificationMethodEnum.PASSWORD_SIGNIN
  | IdentificationMethodEnum.NO_SIGNIN
  | IdentificationMethodEnum.SECRET_QUESTIONS;

export enum ProfileAccessConstraintTypeEnum {
  AT_LEAST_ONE_OF = 'AT_LEAST_ONE_OF'
}

export interface ProfileAccessFieldType {
  key: ProfileFieldKeyType;
  collectionState: ProfileFieldCollectionStateEnum;
  identifierEnabled: boolean;
  displayOrder: number;
}

export interface ProfileAccessConstraintType {
  type: ProfileAccessConstraintTypeEnum;
  fieldKeys: ProfileFieldKeyType[];
}

export interface ProfileAccessType {
  signInMode: ProfileAccessSignInModeType;
  fields: ProfileAccessFieldType[];
  constraints: ProfileAccessConstraintType[];
  secretQuestions: SecretQuestionType[];
}

export interface SiteType {
  question_site: string;
  question_subsite: string;
}

export interface ConsentType {
  id: number;
  has_consent: boolean;
  type: ProfileConsentEnum;
}

export enum ProfileConsentEnum {
  NONE = '',
  SIGNATURE = 'SIGNATURE',
  CHECKBOX = 'CHECKBOX'
}

export interface SecretQuestionType {
  id?: number;
  question: string;
  type: SecretQuestionTypeEnum;
  order?: number;
}

export enum SecretQuestionTypeEnum {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export interface InclusionType {
  has_inclusion_questions: boolean;
  inclusion_questions: InclusionQuestionType[];
}

export interface InclusionQuestionType {
  id?: number;
  question: string;
  eligible_answer: boolean;
}

export enum IdentificationMethodEnum {
  NONE = '',
  PASSWORD_SIGNIN = 'PASSWORD-SIGNIN',
  EMAIL = 'LOGIN-PASSWORD',
  FILE_NUMBER = 'FILE_NUMBER',
  IDENTIFICATION_OFF = 'IDENTIFICATION_OFF',
  NO_SIGNIN = 'NO-SIGNIN',
  SECRET_QUESTIONS = 'SECRET-QUESTIONS',
  WITHOUT_IDENTIFICATION = 'WITHOUT_IDENTIFICATION',
  NICKNAME_PASSWORD= 'NICKNAME-PASSWORD'
}

export const isPasswordSignInMethod = (
  method?: IdentificationMethodEnum | string | null
): boolean => (
  method === IdentificationMethodEnum.NONE
  || method === IdentificationMethodEnum.PASSWORD_SIGNIN
  || method === IdentificationMethodEnum.EMAIL
  || method === IdentificationMethodEnum.NICKNAME_PASSWORD
)

export const isNoSignInMethod = (
  method?: IdentificationMethodEnum | string | null
): boolean => (
  method === IdentificationMethodEnum.NO_SIGNIN
  || method === IdentificationMethodEnum.WITHOUT_IDENTIFICATION
)

export enum AttributeEnum {
  FIRSTNAME = 'has_firstname',
  LASTNAME = 'has_lastname',
  EMAIL = 'has_email',
  PHONENUMBER = 'has_phonenumber',
  EXTERNALID = 'has_external_id',
  VOCALISATION = 'is_vocalisation_enabled',
  NICKNAME = 'has_nickname',
  SITES = 'is_site_requested',
  SPEECH = 'is_speech_recognition_enabled',
  DIRECT_INCLUSION = 'is_direct_inclusion_authorized',
  STRATIFICATION = 'has_stratification',
  CAN_SIGN_UP_ONLY_WITH_INVITATION = 'can_sign_up_only_with_invitation'
}

export type AttributesType = Record<AttributeEnum, boolean>;

export interface IdentificationOptionType {
  label: string;
  value: IdentificationMethodEnum;
  attributeNeeded?: AttributeEnum;
}
